export default __webpack_public_path__ + "static/sam42_manualwork-b27222e342a1d53e92b41716a53edf16.jpg";